import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../Config';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import OtpVerifyCode from '../Partials/OtpVerifyCode/OtpVerifyCode';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import OtpIcon from '../images/OTP.svg';
import {setOtpErrorMsg , setOtpCode, reportDWH, setIsDisplayPopupForHelp } from '../energySaleBlockSlice';
import {validateOtp, createOtp} from '../energySaleBlockAsyncThunk';

const OtpVerifyCodePage = (props) => {

  //page params
  let title = 'נשלח אליך קוד אימות';
  let subTitle = 'מה הקוד שקיבלת?';
  let btnText = 'אפשר להמשיך';
  let currentPageFunction = handlePageContinue;
  let formid = 'energySaleBlock';
  const isDisplayFooter = true;
  const numberOfInputs = 6;
  //page params

  useExtendedEffect((runSideEffects) => {
    gtag4({
      event: props.isStartWithSelectedPackage ? 'Energy_Step3_OtpPage' : 'Energy_Step2_OtpPage',
      step: props.isStartWithSelectedPackage ? '3' :'2',
      action: 'OtpPage',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Otp Page - Display' })
    if (runSideEffects()) {
    }
  },
  [],);


  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <Image className='energy-sale-icon' src={OtpIcon} />
      <h1 className='energy-sale-title'> {title} </h1>
      <h2 className='energy-sale-sub-title'> {subTitle} </h2>
    </div>
  );

  const handleOnChange = (otp) => {
    props.setOtpCode(otp);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handlePageContinue();
    }
  };

  let currentPageView = (
      <OtpVerifyCode onKeyDown={handleKeyDown} numberOfInputs={numberOfInputs} onChange={handleOnChange} onClickResendOtpCodeBtn={handleOnClickResendOtpCodeBtn} error={''} verifyCode={props.otpDetails.verifyCode} />
  );


  return (
    <>
      <div className='energy-sale-content-wrapper'>
        {currentPageHeadline}
        <div className='energy-sale-page-content width-340'>
          <form noValidate id='sale' onSubmit={handleSubmit}>
            {currentPageView}
          </form>
        </div>
      </div>
      <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} error={props.otpDetails.error} formid={formid} />
    </>
  );

  function handlePageContinue() {
    props.setOtpErrorMsg('');
    if (props.otpDetails.verifyCode.length != numberOfInputs) {
      props.setOtpErrorMsg(`יש להזין ${numberOfInputs} תווים`)
      return;
    }
    gtag4({
      event: props.isStartWithSelectedPackage ? 'Energy_Step3_OtpContinueButton' : 'Energy_Step2_OtpContinueButton',
      step: props.isStartWithSelectedPackage ? '3' :'2',
      button: btnText,
      action: 'OtpContinueButton',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: 'Otp Page - Clicked' })
    props.validateOtp();
  }

  function handleOnClickResendOtpCodeBtn() {
    props.setOtpErrorMsg('');
    if (props.otpDetails.numOfAttempts >= Config.verifyCodeAttemptsLimit) {
      props.setOtpErrorMsg('לא ניתן לבצע ניסיונות נוספים');
      return;
    }
    if (props.otpDetails.phoneNumber) {
      gtag4({
        event: props.isStartWithSelectedPackage ? 'Energy_Step3_NotReceivedOtpCode' : 'Energy_Step2_NotReceivedOtpCode',
        step: props.isStartWithSelectedPackage ? '3' :'2',
        button: btnText,
        action: 'NotReceivedOtpCode',
        funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
      });
      props.createOtp();
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    isSubmit: state.energySaleBlock.isSubmit,
    otpDetails: state.energySaleBlock.otpDetails,
    isStartWithSelectedPackage: state.energySaleBlock.isStartWithSelectedPackage
  };
};

const mapDispatchToProps = {
  setOtpCode,
  setOtpErrorMsg,
  validateOtp,
  createOtp,
  reportDWH,
  setIsDisplayPopupForHelp
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyCodePage);
